import { render, staticRenderFns } from "./courseManageImport.vue?vue&type=template&id=b2bbbee0&scoped=true"
import script from "./courseManageImport.vue?vue&type=script&lang=js"
export * from "./courseManageImport.vue?vue&type=script&lang=js"
import style0 from "./courseManageImport.vue?vue&type=style&index=0&id=b2bbbee0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bbbee0",
  null
  
)

export default component.exports